<template>
  <div id="viewGroup">
    <div class="bread container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{path:'/group'}">团购</el-breadcrumb-item>
        <el-breadcrumb-item>商品详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="box">
      <div class="container">
        <el-row :gutter="20">
          <el-col :span="7">
            <div style="border:1px solid #ddd;">
              <img :src="serve + '/'+_.split(data.images, ';', 1)" class="cover">
            </div>
          </el-col>
          <el-col :span="17">
            <div>
              <div class="lv1Text c2">{{data.title}}</div>
              <div class="box2">
                <div class="lv2Text">
                  <span>团购价：</span>
                  <span class="lv0Text c1">&yen;{{data.g_price}}</span>
                  <span>原价：</span>
                  <span class="c1 lv3Text">
                    <s>&yen;{{data.selling_price}}</s>
                  </span>
                </div>
                <div class="lv3Text" style="margin-top:20px;">
                  <span class="s">
                    <i class="fas fa-check-circle"></i> 服务承诺
                  </span>
                  <span class="s">
                    <i class="fas fa-check-circle"></i> 正品保证
                  </span>
                  <span class="s">
                    <i class="fas fa-check-circle"></i> 极速发货
                  </span>
                </div>
              </div>
            </div>
            <div style="margin-top:40px;" class="lv2Text">
              数量：
              <el-input-number
                v-model="num"
                :min="1"
                :max="99"
                size="small"
                style="margin-left:20px;"
              ></el-input-number>
            </div>

            <div style="margin-top:15px;">
              <div style="margin-bottom:10px">
                <span style="position: relative;top:3px;margin-right:5px;" class="lv4Text">
                  <i class="fas fa-user-circle fa-2x"></i>
                </span>
                <span class="lv0Text">{{data.g_number}}人拼</span>
              </div>
              <el-button type="primary" style="width:150px;" @click="groupOrder">发起拼团</el-button>
              <span v-if="data2.total>0">
                <span class="y1">
                  有
                  <span class="lv0Text" style="margin:0 2px;">{{data2.total}}人</span>正在拼团
                </span>
                <el-button type="primary" style="width:150px;" @click="Dialog=true">加入拼团</el-button>
              </span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div style="margin-top:20px" class="container">
      <el-row :gutter="20">
        <el-col :span="18">
          <div>
            <el-tabs type="border-card">
              <el-tab-pane label="商品详情" style="padding:10px 20px;">
                <el-row>
                  <el-col :span="12">
                    <div class="r1">
                      <span class="l1 lv3Text">品牌</span>
                      <span class="lv2Text">{{data.brand}}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="r1">
                      <span class="l1 lv3Text">货号</span>
                      <span class="lv2Text">{{data.item_no}}</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <div class="r1">
                      <span class="l1 lv3Text">产品分类</span>
                      <span class="lv2Text">{{data.classification}}</span>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="r1">
                      <span class="l1 lv3Text">产品规格</span>
                      <span class="lv2Text">{{data.specification}}</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <div class="r1">
                      <span class="l1 lv3Text">货期</span>
                      <span class="lv2Text">{{data.leadtime}}天</span>
                    </div>
                  </el-col>
                </el-row>
                <div v-html="data.info" style="padding: 20px 0;line-height: 1.5em;"></div>
              </el-tab-pane>
              <el-tab-pane label="商品评价" style="padding:40px">
                <div v-if="_.size(comments)>0">
                  <div v-for="(item,index) of comments" :key="index" class="comment-item">
                    <div class="clear top1">
                      <div class="clear-item">
                        <el-image
                          class="avatar"
                          style="width: 50px; height: 50px"
                          :src="item.headImg"
                          fit="cover"
                        ></el-image>
                      </div>
                      <div class="clear-item lv3Text" style="margin:0 10px;">{{item.nickname}}</div>
                      <div class="clear-item" v-if="item.rank">
                        <el-rate
                          class="ra"
                          disabled
                          :value="_.toInteger(item.rank)"
                          :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                        ></el-rate>
                      </div>
                    </div>
                    <el-row>
                      <el-col :span="20" :offset="4">
                        <div class="lv2Text">{{item.content}}</div>
                        <div
                          class="lv3Text"
                          style="font-size:12px;margin:10px 0 5px 0;"
                        >{{dayjs.unix(item.create_date).format('YYYY-MM-DD hh:mm:ss')}}</div>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="pager" align="center">
                    <el-pagination
                    hide-on-single-page
                      background
                      layout="prev, pager, next"
                      :total="total"
                      :page-size="20"
                    ></el-pagination>
                  </div>
                </div>
                <div v-if="_.size(comments)==0">
                  <div class="lv4Text" style="text-align:center;padding: 30px 0;">暂无评论</div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="hot" align="center">
            <div class="t1">热销榜</div>
            <div v-for="(item,index) in hot" :key="index" class="hot-item">
              <img :src="serve + '/'+item.images" class="cover2">
              <router-link :to="'/view?id='+item.id">
                <div style="margin:10px 0;" class="title">
                  {{
                  _.truncate(item.title, {
                  'length': 15
                  })
                  }}
                </div>
              </router-link>
              <div class="lv0Text" style="margin-bottom:10px">&yen;{{item.selling_price}}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="正在进行中的拼团" :visible.sync="Dialog" width="500px">
      <div>
        <div v-for="(item,index) of data2.results" :key="index" class="item">
          <el-row>
            <el-col :span="3">
              <div>
                <img :src="item.headImg" class="avatar">
              </div>
            </el-col>
            <el-col :span="4">
              <div class="nickname">{{item.nickname}}</div>
            </el-col>
            <el-col :span="6" :offset="5">
              <div>
                <span style="float:right;margin-top:15px;margin-right:10px;">
                  还剩
                  <span class="lv0Text">{{item.g_number-item.has_number}}</span>人拼成
                </span>
              </div>
            </el-col>
            <el-col :span="6">
              <div>
                <el-button
                  type="primary"
                  style="float:right;margin-top:10px"
                  size="mini"
                  @click="joinGroupOrder(item.id)"
                >参与拼团</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      //
      data: "",
      num: 1,
      data2: "",
      Dialog: false,
      page: 1,
      comments: "",
      total: 0,
      hot: ""
    };
  },
  created() {
    this.initData();
  },
  methods: {
    joinGroupOrder(id) {
      this.Dialog = false;
      this.$router.push({
        path: "user/joinGroupOrder",
        query: {
          f_group_id: id,
          id: this.data.product_id,
          title: encodeURIComponent(this.data.title),
          item_no: this.data.item_no,
          number: this.num,
          images: this.data.images,
          price: this.data.g_price,
          group_id: this.$route.query.id
        }
      });
    },
    groupOrder() {
      this.$router.push({
        path: "user/groupOrder",
        query: {
          id: this.data.product_id,
          title: encodeURIComponent(this.data.title),
          item_no: this.data.item_no,
          number: this.num,
          images: this.data.images,
          price: this.data.g_price,
          group_id: this.$route.query.id
        }
      });
    },
    initData() {
      this.axios
        .get(this.serve + "/groupBuyDetail", {
          params: {
            group_id: this.$route.query.id
          }
        })
        .then(res => {
          if (res.data.data) {
            this.data = res.data.data;
            var that = this;
            this.axios
              .get(this.serve + "/get_product_comment", {
                params: {
                  product_id: this.data.product_id,
                  page: this.page
                }
              })
              .then(res => {
                if (res.data.data) {
                  this.comments = res.data.data.results;
                  this.total = res.data.data.total;
                }
              });
          }
        });

      this.axios
        .get(this.serve + "/can_join_group", {
          params: {
            group_id: this.$route.query.id
          }
        })
        .then(res => {
          this.data2 = res.data;
        });

      this.axios.get(this.serve + "/product_info_hot").then(res => {
        if (res.data.data) {
          this.hot = res.data.data;
        }
      });
    }
  }
};
</script>
<style lang="scss">
#viewGroup {
  .cover2 {
    display: block;
    width: 255px;
    height: 255px;
  }
  .t1 {
    text-align: center;
    padding: 10px 0;
    background-color: #eee;
  }
  .hot {
    background-color: #fff;
    border: 1px solid #ddd;
    .title:hover {
      text-decoration: underline;
    }
  }
  .hot-item {
    width: 90%;
    margin: 10px auto;
    border: 1px solid #ddd;
    margin-bottom: 20px;
  }
  .comment-item {
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    margin-bottom: 20px;
  }
  .item {
    margin-bottom: 10px;
    border-bottom: 1px solid #ddd;
    padding-bottom: 5px;
  }
  .nickname {
    line-height: 40px;
  }
  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50px;
    overflow: hidden;
  }
  .y1 {
    margin-left: 30px;
    margin-right: 10px;
  }
  .r1 {
    line-height: 2em;
    border-bottom: 1.5px dashed #ddd;
    margin-right: 20px;
    padding-bottom: 5px;
    margin-bottom: 5px;
  }
  .l1 {
    width: 80px;
    display: inline-block;
  }
  padding-bottom: 50px;
  .s {
    margin-right: 15px;
  }
  .c2 {
    font-size: 25px;
  }
  .c1 {
    font-size: 22px;
    margin-right: 10px;
  }
  .box {
    background-color: #fff;
    padding: 20px 40px;
  }
  .cover {
    width: 314px;
    height: 314px;
    margin: 10px;
  }
  .box2 {
    margin-top: 20px;
    background-color: #f2f2f2;
    border: 1px solid #ddd;
    padding: 20px;
  }
}
</style>